import React, {useEffect, useState} from "react";
import {CurrencyExchangeIco, CurrencyNoChangeIco, ReloadIco} from "../../../../../modules/CustomIcons";
import {Button, Tabs, Spin} from "antd";
const { TabPane } = Tabs;

import {ArrowDownward, ArrowUpward, Cached, KeyboardArrowDown, KeyboardArrowUp} from "@mui/icons-material";
import {Spinner} from "constants/constants";
import {dateFormatter, financial} from "../../../../services/helper";
import {Exchange, getCurrencyExchange} from "../../../../services/exhange";
import { useTranslation } from "react-i18next";



const ExchangeComponent:React.FC =() => {
    const {t} = useTranslation()
    const [tableData, setTableData]=useState<Exchange[]>();
    const [tableLoading, setTableLoading]=useState(Spinner);
    const [filterDateTime, setFilterDateTime]=useState(dateFormatter());
    const [showMore, setShowMore]=useState(false);

    const showOnly=['USD', 'EUR', 'RUB', 'GBP', 'JPY', 'CHF']


    const fetchData = async () => {
        setTableLoading({
            ...tableLoading,
            spinning : true
        });

        const data = await getCurrencyExchange();
        let max_index=(showMore) ? 6 : 3;
        const filter_data=data.filter(row => showOnly.slice(0, max_index).indexOf(row.ccy) !=-1)

        setTableData(old_data => filter_data);
        setFilterDateTime(old_date => dateFormatter())

        setTableLoading({
            ...tableLoading,
            spinning : false
        });
    };


    useEffect(() => {
        fetchData();

    }, [showMore]);

    return (
        <>
            <div className='right_side_box full'>

                <div className='full right_side_box_title flex justify_between'>

                    <div className='flex right_side_box_title_left'>
                        <CurrencyExchangeIco />


                        <div className='flex direction_column right_side_box_title_left_title'>
                            <h5>{t("exchangeWidget.exchangeRate")}</h5>
                            <p>{filterDateTime}</p>
                        </div>
                    </div>

                    <Button icon={<ReloadIco />} onClick={fetchData} className='transparent box_reload_ico' />

                </div>

                <div className='full right_side_box_content right_side_box_content_currency'>

                    <Tabs defaultActiveKey="1" className='currency_tabs' centered>

                        <TabPane tab="Bank Respublika" key="1">
                            <Spin{...tableLoading}>
                                <table className='full currency_table'>
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>{t("exchangeWidget.purchase")}</th>
                                        <th>{t("exchangeWidget.sale")}</th>
                                    </tr>
                                    </thead>

                                        <tbody>
                                            {
                                                tableData?.map(row => {
                                                    let buy_trend_icon=<CurrencyNoChangeIco />;

                                                    if (row.buyTrend==-1){
                                                        buy_trend_icon=<ArrowDownward className='currency_arrow currency_arrow_down' />;

                                                    }else if(row.buyTrend==1){
                                                        buy_trend_icon=<ArrowUpward className='currency_arrow currency_arrow_up' />;
                                                    }

                                                    let sell_trend_icon=<CurrencyNoChangeIco />;

                                                    if (row.sellTrend==-1){
                                                        sell_trend_icon=<ArrowDownward className='currency_arrow currency_arrow_down' />;

                                                    }else if(row.sellTrend==1){
                                                        sell_trend_icon=<ArrowUpward className='currency_arrow currency_arrow_up' />;
                                                    }

                                                    return (
                                                        <tr>
                                                            <td>{row.ccy === 'RUB' || row.ccy === 'JPY'?`100 ${row.ccy}` : `1 ${row.ccy}`}</td>
                                                            <td>{buy_trend_icon} {financial(row.buyrate, true)}</td>
                                                            <td>{sell_trend_icon} {financial(row.sellrate, true)}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                </table>
                            </Spin>
                        </TabPane>

                        <TabPane tab={t("exchangeWidget.bank")} key="2">
                            <Spin {...tableLoading} >

                                <table className='full currency_table'>
                                    <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {
                                        tableData?.map(row => {
                                            let buy_trend_icon=<CurrencyNoChangeIco />;

                                            if (row.cbTrend==-1){
                                                buy_trend_icon=<ArrowDownward className='currency_arrow currency_arrow_down' />;

                                            }else if(row.cbTrend==1){
                                                buy_trend_icon=<ArrowUpward className='currency_arrow currency_arrow_up' />;
                                            }

                                            let sell_trend_icon=<CurrencyNoChangeIco />;

                                            if (row.buyTrend==-1){
                                                sell_trend_icon=<ArrowDownward className='currency_arrow currency_arrow_down' />;

                                            }else if(row.buyTrend==1){
                                                sell_trend_icon=<ArrowUpward className='currency_arrow currency_arrow_up' />;
                                            }

                                            return (
                                                <tr>
                                                    <td>{row.ccy === 'RUB' || row.ccy === 'JPY'? `100 ${row.ccy}` : `1 ${row.ccy}`}</td>
                                                    <td>{buy_trend_icon} {financial(row.cbrate, true)}</td>
                                                    <td></td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>

                            </Spin>
                        </TabPane>
                    </Tabs>

                    <div className='full flex justify_center align_center show_more_currencies' style={{cursor : 'pointer'}} onClick={() => { setShowMore(!showMore) }} >
                        <p>
                            {
                                showMore ? t("common.close") : t("exchangeWidget.more")
                            }

                        </p>
                        <Button icon={(showMore) ? <KeyboardArrowUp /> : <KeyboardArrowDown />} className='transparent box_arrow_btn' />
                    </div>

                </div>

            </div>
        </>
    )
}

export default ExchangeComponent;
